import { HELPER_BASE_RATE } from 'js/part-time-helper-cost'

// What a part-time helper does in a standard booking. Rendered by the hub's
// package cards and by the HelperServiceScope sheet. The same scope used to be
// pasted into six HTML strings in two pages.
export const HELPER_SCOPE = {
    notice: 'The booked hours may or may not be sufficient to cover all inclusions. Please discuss your priorities with the helper before the service starts.',
    disclaimers: [
        'The helper will not be carrying any equipment.',
        'Not in scope: Move-out, Post-renovation or Spring Cleaning.',
        'This service is for residential premises only.',
    ],
    sections: [
        { key: 'rooms', title: 'All Rooms', items: ['Dusting of surfaces', 'Sweeping/vacuuming of floors', 'Floor mopping', 'Wiping accessible indoor side of window'] },
        { key: 'bedrooms', title: 'Bedrooms', items: ['Bed sheet changing'] },
        { key: 'kitchen', title: 'Kitchen', items: ['Dishwashing', 'Countertop wiping', 'Hood cleaning & stove cleaning', 'Wiping accessible kitchen appliances'] },
        { key: 'bathroom', title: 'Bathroom', items: ['Cleaning sink and toilet bowl', 'Floor and wall cleaning', 'Wiping surfaces, mirrors and glass'] },
        { key: 'fan', title: 'Fan', items: ['Wiping of easily accessible standing or table fan (ceiling fan is out of scope)'] },
    ],
}

// Suggested hours per home size. Every `unit` must be one of
// HELPER_SERVICE_HOURS; buildHelperDeals drops any package that isn't.
const PACKAGES = [
    { title: '1 Bedroom', unit: 2, image: 'part-time-helper/part-time-helper-in-blue.jpg' },
    { title: '1 Bedroom (with ironing)', unit: 2.5, image: 'part-time-helper/part-time-helper-in-living-room-edit.jpg' },
    { title: '2 Bedrooms', unit: 3, image: 'blog/living/part-time-helper/helper-to-clean-bathroom-toilet.jpg' },
    { title: '2 Bedrooms (with ironing)', unit: 3.5, image: 'blog/living/part-time-helper/helper-cleaning-kitchen-cabinets.jpg' },
    { title: '3 Bedrooms', unit: 4, image: 'blog/living/part-time-helper/part-time-cleaners-singapore.jpg' },
]

// Package prices come from the same calculator rows as the booking card.
// The deals used to have their own hand-typed prices, so a "deal" for 3 hours
// ($69.95) cost more than booking 3 hours from the card ($62.32).
// originalCost is the undiscounted base rate for the same hours, which the
// calculator discounts from.
export const buildHelperDeals = (helperService) =>
    PACKAGES
        .map((pkg) => {
            const row = helperService.find((r) => r.unit === pkg.unit)
            if (!row) return null
            return {
                ...pkg,
                cost: Number(row.rate),
                originalCost: Number((HELPER_BASE_RATE * pkg.unit).toFixed(2)),
            }
        })
        .filter(Boolean)
